export default "__VITE_ASSET__6cf89b20__"